import * as React from 'react';
import {Props} from "./types";
import {CarrierSelector} from "./carrier-selector";
import { usePdpCompaniesQuery } from '@coverright/data-access/medicare';
import { mainBackendApolloClient } from '@coverright/data-access/apollo-clients';
import { Box } from '@mui/material';
import { Tooltip } from '@coverright/ui/inputs';
import { useMemo } from 'react';

export const PdpCarrierSelector = (props: Props) => {
  const {zip, county, planYear} = props;
  const {data} = usePdpCompaniesQuery({
    client: mainBackendApolloClient,
    variables: {
      filter: {zip, countyName: county, planYear, showAllPlans: true},
    },
    skip: !county || !zip || !planYear
  })

  const companies = (data?.pdpCompanies || []).filter((c: any) => c.count).map((c: any) => `${c.name} (${c.count})`) || []

  const helperTip = useMemo(() => {
    const fields = [];
    if (!zip || !county) {
      fields.push('zip')
    }
    if (!planYear) {
      fields.push('effective date')
    }

    if (fields.length) {
      return `You have to fill ${fields.join(', ')} to select carrier`
    }

    return ''
  }, [zip, county, planYear])

  return <Tooltip sx={{flex: 1, display: 'flex'}} title={helperTip}>
    <Box>
      <CarrierSelector {...props} companies={companies} />
    </Box>
  </Tooltip>
};
